var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-white rounded-circle p-1" }, [
    _c(
      "span",
      {
        staticClass:
          "fa-stack fa-1x color-primary-2 font-16 mr-1 d-flex justify-content-center"
      },
      [
        _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
        _c("em", { staticClass: "fa-stack-1x fa-inverse", class: _vm.i })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }